<template>
  <div>
    <chat-window
      :current-user-id="currentUserId"
      v-if="rooms.length > 0"
      :rooms="rooms"
      :messagesLoaded="messagesLoaded"
      :loading-rooms="false"
      :rooms-loaded="true"
      :messages="messages"
      @send-message="sendMessage"
      @fetch-messages="changeRoom"
      @open-file="openFile"
      :show-audio="false"
      :show-reaction-emojis="false"
      :show-add-room="false"
      :show-files="false"
      :text-formatting="false"
    >
            <template v-slot:message="{message}">
              <div class="msg" v-bind:class="{'left-msg': getUID() != message.senderId, 'right-msg': getUID() == message.senderId}">
                <div
                    class="msg-img"
                    :style="`background-image: url(${message.avatar})`"
                ></div>

                <div class="msg-bubble">
                  <div class="msg-info">
                    <div class="msg-info-name">{{ message.senderId.split("#")[1] }}</div>
                    <div class="msg-info-time">{{ message.date }}</div>
                  </div>

                  <div class="msg-text">
                    {{ message.content }}
                  </div>
                  <div v-if="message.file">
                    Attached file:
                    <a :href="message.file.url" :download="message.file.name">{{message.file.name}}</a>
                  </div>
                </div>
              </div>
            </template>
    </chat-window>
  </div>
  <!--  <chat-window :current-user-id="currentUserId"-->
  <!--               :rooms="rooms"-->
  <!--               :messages="messages"-->
  <!--               @fetch-more-rooms="test(1)"-->
  <!--               @fetch-messages="test(2)"-->
  <!--               @send-message="test(3)"-->
  <!--               @edit-message="test(4)"-->
  <!--               @delete-message="test(5)"-->
  <!--               @open-file="test(6)"-->
  <!--               @open-user-tag="test(7)"-->
  <!--               @add-room="test(8)"-->
  <!--               @room-action-handler="test(9)"-->
  <!--               @menu-action-handler="test(10)"-->
  <!--               @send-message-reaction="test(11)"-->
  <!--               @typing-message="test(12)"-->
  <!--               @toggle-rooms-list="test(13)"-->
  <!--  />-->
</template>

<script>
import ChatWindow from "vue-advanced-chat";
import "vue-advanced-chat/dist/vue-advanced-chat.css";
import moment from "moment";
export default {
  props: ["ws"],
  components: {
    ChatWindow
  },
  data() {
    return {
      messagesLoaded: true,
      rooms: [],
      messages: [],
      currentUserId: this.getUID(),
      connection: null
    };
  },
  methods: {
    getUID() {
      return String(JSON.parse(localStorage.getItem("userInfo")).id+"#"+JSON.parse(localStorage.getItem("userInfo")).name);
    },
    changeRoomE(e) {
      window.e = e;
      //console.log(e.room.roomId)
    },
    test(e) {
      window.e = e;
      //console.log("TEST INVOKED!", e)
      //console.log(e)
    },
    sendMessage(e) {
      let token = localStorage.getItem("token");
      let data = {
        user: "user",
        token: token,
        message: e.content,
        files: []
      };
      // if (this.files.length > 0) {
      //   data.files = this.files
      // }
      this.connection.send(JSON.stringify(data));
      this.message = "";
      this.files = [];
    },
    getChatMessages(wid) {
      this.messagesLoaded = false;

      // use timeout to imitate async server fetched data
      setTimeout(() => {
        this.$upskill.chat(wid).then(res => {
          this.messages = [];
          if (res.data.data) {
            this.messages = res.data.data.map(o => {
              let hasFile = o.files.length > 0;
              // let fileStr = ""
              // if (hasFile) {
              //   o.files.forEach(f => {
              //     fileStr += `
              //     <a href="${f.link}" target="_blank">${f.name}</a><br>
              //     `
              //   })
              // }

              let msgJson = {
                _id: o.time,
                content: o.message,
                senderId: o.sender,
                username: o.sender,
                avatar: o.avatar,
                date: moment(o.time).format("lll"),
                timestamp: moment(o.time).format("lll"),
                system: false,
                saved: true,
                distributed: true,
                seen: true,
                disableActions: true,
                disableReactions: true
              };
              if (hasFile) {
                msgJson.file = {
                  name: o.files[0].name,
                  type: o.files[0].name.split(".").pop(),
                  audio: false,
                  size: 1000,
                  url:
                    "https://upskill-files.s3-ap-southeast-1.amazonaws.com/" +
                    o.files[0].link
                };
              }
              return msgJson;
            });
          }
          this.messagesLoaded = true;
        });
      });
      // this.$upskill.chat(wid).then(res => {
      //   if (res.data.data) {
      //     this.messages = res.data.data.map(o => {
      //       return {
      //         _id: o.time,
      //         content: o.message,
      //         senderId: o.sender,
      //         username: o.sender,
      //         avatar: o.avatar,
      //         date: moment(o.time).format("lll"),
      //         timestamp: moment(o.time).format("lll"),
      //         system: false,
      //         saved: true,
      //         distributed: true,
      //         seen: true,
      //         disableActions: true,
      //         disableReactions: true
      //       }
      //     })
      //   }
      // })
    },
    openFile(e) {
      // console.log(e)
      // console.log(e.message.file)
      window.open(e.message.file.url, "_blank")
    },
    changeRoom(e) {
      let roomId = e.room.roomId;
      // switches chat tab ie. reset chat and message
      this.message = "";
      this.chat = [];
      if (this.connection) {
        this.connection.close(1000, "change workshop");
      }

      // set selected chatroom
      // this.selected = w
      let self = this;

      this.connection = new WebSocket(this.$upskill.chatws(roomId));
      this.getChatMessages(roomId);

      this.connection.onclose = function(event) {
        //console.log(event);
        window.e = event;
        self.canConnect = false;
      };
      this.connection.onerror = function(event) {
        //console.log(event);
        window.e = event;
        self.canConnect = false;
      };

      this.connection.onmessage = function(event) {
        window.e = event;
        // console.log("MESSAGE")
        // console.log(event);
        // console.log(event.data);
        // self.chat.push(JSON.parse(event.data))

        let template = JSON.parse(event.data);
        let msgTemplate = {
          _id: template.time,
          content: template.message,
          senderId: template.sender,
          username: template.sender,
          avatar: template.avatar,
          date: moment(template.time).format("lll"),
          timestamp: moment(template.time).format("lll"),
          system: false,
          saved: true,
          distributed: true,
          seen: true,
          disableActions: true,
          disableReactions: true
        };
        self.messages.push(msgTemplate);
      };

      this.connection.onopen = function(event) {
        //console.log(event);
        window.e = event;
        self.canConnect = true;
        //console.log("Successfully connected to the uchat server...")
        self.messagesLoaded = true;
      };
      this.chatBox = true;
    }
  },
  created() {
    let rooms = this.ws.map(o => {
      let img = o.image.startsWith("/storage")
        ? "https://backend.upskill.com.bd" + o.image
        : "https://backend.upskill.com.bd/storage/" + o.image;
      return { roomId: o.id, roomName: o.name, avatar: img, users: [] };
    });
    this.rooms = rooms;
  }
};
</script>

<style>
:root {
  --body-bg: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --msger-bg: #fff;
  --border: 2px solid #ddd;
  --left-msg-bg: #ececec;
  --right-msg-bg: #579ffb;
}
.msger {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  width: 100%;
  max-width: 867px;
  margin: 25px 10px;
  height: calc(100% - 50px);
  border: var(--border);
  border-radius: 5px;
  background: var(--msger-bg);
  box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.2);
}

.msger-header {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: var(--border);
  background: #eee;
  color: #666;
}

.msger-chat {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}
.msger-chat::-webkit-scrollbar {
  width: 6px;
}
.msger-chat::-webkit-scrollbar-track {
  background: #ddd;
}
.msger-chat::-webkit-scrollbar-thumb {
  background: #bdbdbd;
}
.msg {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}
.msg:last-of-type {
  margin: 0;
}
.msg-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  background: #ddd;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
}
.msg-bubble {
  max-width: 450px;
  padding: 15px;
  border-radius: 15px;
  background: var(--left-msg-bg);
}
.msg-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.msg-info-name {
  margin-right: 10px;
  font-weight: bold;
}
.msg-info-time {
  font-size: 0.85em;
}

.left-msg .msg-bubble {
  border-bottom-left-radius: 0;
}

.right-msg {
  flex-direction: row-reverse;
}
.right-msg .msg-bubble {
  background: var(--right-msg-bg);
  color: #fff;
  border-bottom-right-radius: 0;
}
.right-msg .msg-img {
  margin: 0 0 0 10px;
}

.msger-inputarea {
  display: flex;
  padding: 10px;
  border-top: var(--border);
  background: #eee;
}
.msger-inputarea * {
  padding: 10px;
  border: none;
  border-radius: 3px;
  font-size: 1em;
}
.msger-input {
  flex: 1;
  background: #ddd;
}
.msger-send-btn {
  margin-left: 10px;
  background: rgb(0, 196, 65);
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.23s;
}
.msger-send-btn:hover {
  background: rgb(0, 180, 50);
}
</style>
